// extracted by mini-css-extract-plugin
export default {"truncate":"TruncatedText_truncate__-Ou++"};